import { t } from "@/i18n-js/instance";
import { AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS } from "@circle-react/components/SettingsApp/Workflows/constants";
import { Icon } from "@circle-react-shared/Icon";
import type { ActionOption } from "../../types";
import { FormRenamePostTitle } from "./FormRenamePostTitle";
import type { HistoryDetailViewRenamedPostProps } from "./HistoryDetailViewRenamedPost";
import { HistoryDetailViewRenamedPost } from "./HistoryDetailViewRenamedPost";
import { useIsAiAutomationsV2Enabled } from "./useIsAiAutomationsV2Enabled";

export const renamePostTitle: Readonly<
  ActionOption<HistoryDetailViewRenamedPostProps>
> = {
  label: t("settings.workflows.form.actions.ai_agents_rename_post_title"),
  textLabel: t("settings.workflows.form.actions.ai_agents_rename_post_title"),
  value: "ai_agents_rename_post_title",
  group: t("settings.workflows.form.action_groups.ai_agents"),
  leftAddon: <Icon type="16-ai-rename" size={16} className="!h-4 !w-4" />,
  formComponent: FormRenamePostTitle,
  viewComponent: null,
  historyDetailViewComponent: HistoryDetailViewRenamedPost,
  icon: "chat",
  isApplicableToMembersOnly: false,
  availablePlanTier:
    AVAILABLE_WORKFLOW_ACTION_AS_PER_PLAN_TIERS.HIGHER_TIER_PLAN_ONLY,
  released: useIsAiAutomationsV2Enabled,
} as const;
